<div class="dialog-container">
  <!-- Instrukcja - mobilnie na górze, desktopowo po prawej -->
  <div class="instructions-section order-first lg-custom:order-last bg-slate-50 dark:bg-slate-900/50">
    <div class="p-6">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
          <mat-icon class="icon-size-5 text-blue-600 dark:text-blue-400" [svgIcon]="'tabler_outline:book'"></mat-icon>
        </div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">Instrukcja konfiguracji</h3>
      </div>
      
      <!-- Krok 1 -->
      <div class="mb-6">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-6 h-6 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-bold">1</div>
          <h4 class="font-semibold text-gray-900 dark:text-white">Zaloguj się do portalu KSeF</h4>
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 ml-8 mb-3">
          Wejdź na stronę 
          <a href="https://ap.ksef.mf.gov.pl/web/" target="_blank" class="text-primary-600 dark:text-primary-400 underline hover:no-underline font-medium">https://ap.ksef.mf.gov.pl/web/</a> 
          i zaloguj się używając Profilu Zaufanego lub certyfikatu kwalifikowanego.
        </p>
        <div class="ml-8 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
          <img src="assets/images/ksef/ksef_logowanie.png" alt="KSeF Login Page Screenshot" class="mt-2 rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
        </div>
      </div>
      
      <!-- Krok 2 -->
      <div class="mb-6">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-6 h-6 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-bold">2</div>
          <h4 class="font-semibold text-gray-900 dark:text-white">Przejdź do zakładki "Tokeny"</h4>
        </div>
        <!-- <p class="text-sm text-gray-600 dark:text-gray-400 ml-8 mb-3">
          Po zalogowaniu, w menu bocznym znajdziesz zakładkę <strong>"Tokeny"</strong>. 
          Kliknij ją, aby przejść do zarządzania tokenami autoryzacyjnymi.
        </p> -->
        <div class="ml-8 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
          <!-- <mat-icon class="icon-size-12 text-gray-300 dark:text-gray-600" [svgIcon]="'tabler_outline:photo'"></mat-icon>
          <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">Menu z zakładką "Tokeny"</p> -->
             <img src="assets/images/ksef/generuj_token.png" alt="KSeF Login Page Screenshot" class="mt-2 rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
        </div>
      </div>
      
      <!-- Krok 3 -->
      <div class="mb-6">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-6 h-6 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-bold">3</div>
          <h4 class="font-semibold text-gray-900 dark:text-white">Kliknij Generuj token</h4>
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 ml-8 mb-3">
         Uzupełnij nazwę tokena np. <strong>Fakturnia_pl</strong> i wybierz następujące uprawnienia:
        </p>
        <div class="ml-8 mb-3 p-3 rounded-lg bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800">
          <p class="text-sm font-medium text-emerald-800 dark:text-emerald-300 mb-2">Wymagane uprawnienia:</p>
          <ul class="text-sm text-emerald-700 dark:text-emerald-400 space-y-1">
            
            <li class="flex items-center gap-2">
              <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:check'"></mat-icon>
              <span>Wystawianie faktur</span>
            </li>
            <li class="flex items-center gap-2">
              <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:check'"></mat-icon>
              <span>Przeglądanie faktur</span>
            </li>
            <li class="flex items-center gap-2">
              <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:check'"></mat-icon>
              <span>Przeglądanie uprawnień</span>
            </li>
          </ul>
        </div>
        <div class="ml-8 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
          <!-- <mat-icon class="icon-size-12 text-gray-300 dark:text-gray-600" [svgIcon]="'tabler_outline:photo'"></mat-icon>
          <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">Formularz generowania tokena</p> -->
           <img src="assets/images/ksef/generowanie_tokena.png" alt="KSeF Login Page Screenshot" class="mt-2 rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
        </div>
      </div>
      
      <!-- Krok 4 -->
      <div class="mb-6">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-6 h-6 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-bold">4</div>
          <h4 class="font-semibold text-gray-900 dark:text-white">Skopiuj token</h4>
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 ml-8 mb-3">
          Po wygenerowaniu tokena, skopiuj go i wklej w polu formularza po prawej stronie. 
          <strong class="text-amber-600 dark:text-amber-400">Uwaga:</strong> Token jest wyświetlany tylko raz - zapisz go w bezpiecznym miejscu!
        </p>
        <div class="ml-8 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
          <!-- <mat-icon class="icon-size-12 text-gray-300 dark:text-gray-600" [svgIcon]="'tabler_outline:photo'"></mat-icon>
          <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">Wygenerowany token</p> -->
          
          <img src="assets/images/ksef/wygenerowany_token_do_skopiowania.png" alt="KSeF Login Page Screenshot" class="mt-2 rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
        </div>
      </div>
      
      <!-- Info box -->
      <div class="p-4 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
        <div class="flex items-start gap-3">
          <mat-icon class="icon-size-5 text-amber-600 dark:text-amber-400 flex-shrink-0" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
          <div class="text-sm text-amber-700 dark:text-amber-300">
            <p class="font-medium">Ważne informacje</p>
            <ul class="mt-2 space-y-1 list-disc list-inside">
              <li>Token jest poufny - nie udostępniaj go nikomu</li>
              <li>Możesz w każdej chwili unieważnić token w portalu KSeF</li>
              <li>Jeden token może być używany tylko przez jedną aplikację</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Formularz - zawsze po lewej na desktopie -->
  <div class="form-section flex flex-col">
    <!-- Header -->
    <div class="p-6 pb-2">
      <div class="flex items-center gap-4">
        <div class="w-12 h-12 rounded-xl bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
          <mat-icon class="icon-size-6 text-primary-600 dark:text-primary-400" [svgIcon]="'tabler_outline:key'"></mat-icon>
        </div>
        <div>
          <h2 class="text-xl font-bold text-gray-900 dark:text-white">
            {{ data.hasToken ? 'Zmień token KSeF' : 'Dodaj token KSeF' }}
          </h2>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
            Token autoryzacyjny dla NIP: {{ data.nip || 'nie określono' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="px-6 py-4 flex-1">
      <!-- Token input -->
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>Token autoryzacyjny KSeF</mat-label>
        <textarea matInput 
                  [formControl]="tokenControl" 
                  placeholder="Wklej tutaj token autoryzacyjny skopiowany z portalu KSeF..."
                  rows="6"
                  class="font-mono text-sm"></textarea>
        <mat-hint>Token zostanie zaszyfrowany i bezpiecznie zapisany</mat-hint>
        <mat-error *ngIf="tokenControl.hasError('required')">Token jest wymagany</mat-error>
        <mat-error *ngIf="tokenControl.hasError('minlength')">Token jest za krótki</mat-error>
      </mat-form-field>

      <!-- Warning for existing token -->
      <div *ngIf="data.hasToken" class="mt-4 p-3 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
        <div class="flex items-center gap-2">
          <mat-icon class="icon-size-4 text-amber-600 dark:text-amber-400" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
          <p class="text-sm text-amber-700 dark:text-amber-300">
            Zapisanie nowego tokena nadpisze istniejący token.
          </p>
        </div>
      </div>
      
      <!-- Security info -->
      <div class="mt-4 p-3 rounded-lg bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700">
        <div class="flex items-start gap-2">
          <mat-icon class="icon-size-4 text-slate-500 dark:text-slate-400 mt-0.5" [svgIcon]="'tabler_outline:shield-check'"></mat-icon>
          <p class="text-xs text-slate-600 dark:text-slate-400">
            Twój token jest szyfrowany algorytmem AES-256 i przechowywany w bezpieczny sposób. 
            Nigdy nie przesyłamy go w jawnej formie.
          </p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 pb-6 flex justify-end gap-3 border-t border-gray-200 dark:border-gray-700 pt-4 mt-auto">
      <button mat-stroked-button (click)="cancel()">
        Anuluj
      </button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="tokenControl.invalid">
        <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:check'"></mat-icon>
        <span class="ml-1">Zapisz token</span>
      </button>
    </div>
  </div>
</div>
